import React, { useContext } from 'react';
import NumberFormat from 'react-number-format';
import { SettingsContext } from '../context';

function CurrencyFormat(props) {
  const { settings } = useContext(SettingsContext);
  const symbolLookup = {
    "AFA": "؋",
    "ALL": "Lek",
    "DZD": "دج",
    "AOA": "Kz",
    "ARS": "$",
    "AMD": "֏",
    "AWG": "ƒ",
    "AUD": "$",
    "AZN": "m",
    "BSD": "B$",
    "BHD": ".د.ب",
    "BDT": "৳",
    "BBD": "Bds$",
    "BYR": "Br",
    "BEF": "fr",
    "BZD": "$",
    "BMD": "$",
    "BTN": "Nu.",
    "BTC": "฿",
    "BOB": "Bs.",
    "BAM": "KM",
    "BWP": "P",
    "BRL": "R$",
    "GBP": "£",
    "BND": "B$",
    "BGN": "Лв.",
    "BIF": "FBu",
    "KHR": "KHR",
    "CAD": "$",
    "CVE": "$",
    "KYD": "$",
    "XOF": "CFA",
    "XAF": "FCFA",
    "XPF": "₣",
    "CLP": "$",
    "CNY": "¥",
    "COP": "$",
    "KMF": "CF",
    "CDF": "FC",
    "CRC": "₡",
    "HRK": "kn",
    "CUC": "$, CUC",
    "CZK": "Kč",
    "DKK": "Kr.",
    "DJF": "Fdj",
    "DOP": "$",
    "XCD": "$",
    "EGP": "ج.م",
    "ERN": "Nfk",
    "EEK": "kr",
    "ETB": "Nkf",
    "EUR": "€",
    "FKP": "£",
    "FJD": "FJ$",
    "GMD": "D",
    "GEL": "ლ",
    "DEM": "DM",
    "GHS": "GH₵",
    "GIP": "£",
    "GRD": "₯, Δρχ, Δρ",
    "GTQ": "Q",
    "GNF": "FG",
    "GYD": "$",
    "HTG": "G",
    "HNL": "L",
    "HKD": "$",
    "HUF": "Ft",
    "ISK": "kr",
    "INR": "₹",
    "IDR": "Rp",
    "IRR": "﷼",
    "IQD": "د.ع",
    "ILS": "₪",
    "ITL": "L,£",
    "JMD": "J$",
    "JPY": "¥",
    "JOD": "ا.د",
    "KZT": "лв",
    "KES": "KSh",
    "KWD": "ك.د",
    "KGS": "лв",
    "LAK": "₭",
    "LVL": "Ls",
    "LBP": "£",
    "LSL": "L",
    "LRD": "$",
    "LYD": "د.ل",
    "LTL": "Lt",
    "MOP": "$",
    "MKD": "ден",
    "MGA": "Ar",
    "MWK": "MK",
    "MYR": "RM",
    "MVR": "Rf",
    "MRO": "MRU",
    "MUR": "₨",
    "MXN": "$",
    "MDL": "L",
    "MNT": "₮",
    "MAD": "MAD",
    "MZM": "MT",
    "MMK": "K",
    "NAD": "$",
    "NPR": "₨",
    "ANG": "ƒ",
    "TWD": "$",
    "NZD": "$",
    "NIO": "C$",
    "NGN": "₦",
    "KPW": "₩",
    "NOK": "kr",
    "OMR": ".ع.ر",
    "PKR": "₨",
    "PAB": "B/.",
    "PGK": "K",
    "PYG": "₲",
    "PEN": "S/.",
    "PHP": "₱",
    "PLN": "zł",
    "QAR": "ق.ر",
    "RON": "lei",
    "RUB": "₽",
    "RWF": "FRw",
    "SVC": "₡",
    "WST": "SAT",
    "SAR": "﷼",
    "RSD": "din",
    "SCR": "SRe",
    "SLL": "Le",
    "SGD": "$",
    "SKK": "Sk",
    "SBD": "Si$",
    "SOS": "Sh.so.",
    "ZAR": "R",
    "KRW": "₩",
    "XDR": "SDR",
    "LKR": "Rs",
    "SHP": "£",
    "SDG": ".س.ج",
    "SRD": "$",
    "SZL": "E",
    "SEK": "kr",
    "CHF": "CHf",
    "SYP": "LS",
    "STD": "Db",
    "TJS": "SM",
    "TZS": "TSh",
    "THB": "฿",
    "TOP": "$",
    "TTD": "$",
    "TND": "ت.د",
    "TRY": "₺",
    "TMT": "T",
    "UGX": "USh",
    "UAH": "₴",
    "AED": "إ.د",
    "UYU": "$",
    "USD": "$",
    "UZS": "лв",
    "VUV": "VT",
    "VEF": "Bs",
    "VND": "₫",
    "YER": "﷼",
    "ZMK": "ZK"
};
let cs = (settings && symbolLookup[settings.currency&&settings.currency.value])||symbolLookup["USD"];

  let { value } = props;
  let modifiedValue = false;
  let amount = String(value);
  // add trailing 0 to numbers like 1.5
  let components = amount.split('.');
  if ( components.length > 1 && components[1].length < 2) {
    modifiedValue = parseFloat(value).toFixed(2);
  } 
  let newProps = {...props};
  newProps.value = modifiedValue !== false ? modifiedValue : props.value;

  return <NumberFormat {...newProps} thousandSeparator={true} prefix={props.prefix||cs} decimalScale={2} displayType={props.type==='text'?'input':'text'} />
}

export default CurrencyFormat;